export default (node) => {
  // switch between product and lifestyle images
  const handleSwitch = (e) => {
    const switchTo = e.currentTarget.dataset.collectionSwitch;

    const allProducts = document.querySelectorAll(
      '.kuResults .kuProdWrapHolder [data-product-card]'
    );

    allProducts.forEach((product) => {
      const productImage = product.querySelector('[data-image-index="0"]');
      let styleImage = product.querySelector('[data-image-style]') ? product.querySelector('[data-image-style]').getAttribute('data-image-style') : null;

      if (styleImage) {
        const originalImage = product
          .querySelector('[data-first-image]')
          .getAttribute('data-first-image');

        productImage.innerHTML =
          switchTo === 'product' ? originalImage : styleImage;
      }
    });

    const collectionSwitches = document.querySelectorAll(
      '[data-collection-switches] > button'
    );
    collectionSwitches.forEach((button) => {
      if (button.dataset.collectionSwitch === switchTo) {
        button.classList.add(
          'text-gray-90',
          '!border-gray-20',
          'hover:!bg-gray-10',
          '!bg-gray-10'
        );
        button.classList.remove('text-gray-70');
      } else {
        button.classList.remove(
          'text-gray-90',
          '!border-gray-20',
          'hover:!bg-gray-10',
          '!bg-gray-10'
        );
        button.classList.add('text-gray-70');
      }
    });
  };

  const init = () => {
    const collectionSwitches = document.querySelectorAll(
      '[data-collection-switches] > button'
    );
    collectionSwitches.forEach((button) => {
      button.addEventListener('click', handleSwitch);
    });
  };

  init();
};
